module.exports = __webpack_public_path__ + "img/bg.5dd4f40a.webp";